import React from "react";

const IndustriesServed = () => {
  return (
    <div className="mvs-use-cases-wrapper">
      <h1>Industries Served</h1>
      <div className="row">
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
              >
                <path
                  fill="#f3792c"
                  d="M2 7V4q0-.825.588-1.412T4 2h3v2H4v3zm5 15H4q-.825 0-1.412-.587T2 20v-3h2v3h3zm10 0v-2h3v-3h2v3q0 .825-.587 1.413T20 22zm3-15V4h-3V2h3q.825 0 1.413.588T22 4v3zm-6.5 2.5q-.825 0-1.412-.587T11.5 7.5t.588-1.412T13.5 5.5t1.413.588T15.5 7.5t-.587 1.413T13.5 9.5m-.7 8.5h-4l1-5.1l-1.8.7V17H6v-4.7l3.95-1.7q.875-.375 1.288-.487T12 10q.525 0 .975.275T13.7 11l1 1.6q.65 1.05 1.763 1.725T19 15v2q-1.65 0-3.088-.687T13.5 14.5z"
                />
              </svg>
              <p>Automotive for defect detection in components</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="#f3792c"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="M7 19.4V4.6a.6.6 0 0 1 .6-.6h8.8a.6.6 0 0 1 .6.6v14.8a.6.6 0 0 1-.6.6H7.6a.6.6 0 0 1-.6-.6m7 .6v2.5M10 20v2.5M14 4V1.5M10 4V1.5M7 12H4.5m15 0H17M7 6.5H4.5m15 0H17m-10 11H4.5m15 0H17"
                />
              </svg>
              <p>Electronics for precision assembly verification</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 50 50"
              >
                <path
                  fill="#f3792c"
                  d="M39.352 17H10.4C5.23 17 1 20.64 1 25.5S5.23 34 10.4 34h28.952c5.168 0 9.398-3.641 9.398-8.5c0-4.86-4.23-8.5-9.398-8.5m.003 15H25V19h14.355c3.812 0 6.934 2.915 6.934 6.5S43.168 32 39.355 32"
                />
              </svg>
              <p>Pharmaceuticals for packaging inspection</p>
            </div>
          </div>
        </div>
        <div className="col-12 col-sm-6">
          <div className="card">
            <div className="title">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 26 26"
              >
                <path
                  fill="#f3792c"
                  d="m11.656.656l-1.312.688l1 2l-2-1l-.688 1.312L11.344 5H2a1 1 0 0 0-.094 0a1 1 0 0 0-.093 0A1 1 0 0 0 1 6v4a1 1 0 0 0 1 1v13a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V11a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-9.344l2.688-1.344l-.688-1.312l-2 1l1-2l-1.312-.688L13 3.344zM3 7h9v2H3.187A1 1 0 0 0 3 8.969zm11 0h9v2h-9zM4 11h8v12H4zm10 0h8v12h-8z"
                />
              </svg>
              <p>Food & Beverage for packaging quality and labeling</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesServed;
